import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { Tooltip } from "react-tippy"

import "./tooltip.sass"

const FpTooltip = ({
  label,
  html,
  showArrow,
  position,
  disabled,
  children,
}) => {
  return (
    <Tooltip
      title={label}
      html={html}
      arrow={showArrow}
      position={position}
      animation="fade"
      animateFill={false}
      duration={0}
      touchHold={true}
      trigger={"mouseenter focus"}
      disabled={disabled}
    >
      {children}
    </Tooltip>
  )
}

FpTooltip.propTypes = {
  label: PropTypes.string,
  html: PropTypes.node,
  showArrow: PropTypes.bool,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  position: PropTypes.oneOf(["top", "top-start"]),
}

FpTooltip.defaultProps = {
  disabled: false,
  position: "top",
  showArrow: true,
}

export default FpTooltip
